import { PaymentMethodCode } from '@src/domains/payments/types/payment';

export const PaymentMethodFormKind = {
  Card: 'card',
  Pix: 'pix',
  Unavailable: 'unavailable',
} as const;

export type PaymentMethodFormKind = (typeof PaymentMethodFormKind)[keyof typeof PaymentMethodFormKind];

export const resolvePaymentMethodForm = (code?: PaymentMethodCode): PaymentMethodFormKind => {
  switch (code) {
    case PaymentMethodCode.CreditCard:
    case PaymentMethodCode.DebitCard:
      return PaymentMethodFormKind.Card;
    case PaymentMethodCode.Pix:
      return PaymentMethodFormKind.Pix;
    default:
      return PaymentMethodFormKind.Unavailable;
  }
};
